import { render, staticRenderFns } from "./DiscernmentAge.vue?vue&type=template&id=34a37b75&scoped=true"
import script from "./DiscernmentAge.vue?vue&type=script&lang=js"
export * from "./DiscernmentAge.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentAge.vue?vue&type=style&index=0&id=34a37b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a37b75",
  null
  
)

export default component.exports